export default "__VITE_ASSET__1B$vRQfN__"